import { isServerside } from '../core/utils/isServerside';

export const getWidgetsAssetsEndpoint = (): string | undefined => {
  // An option for the hawk-client to override the endpoint to avoid ad blockers
  if (!isServerside() && window.hawk_assets_endpoint) {
    return window.hawk_assets_endpoint;
  }

  return process.env.ASSETS_ENDPOINT;
};
